export default "__VITE_ASSET__CkVm3THt__"